// import LoginLayout from '@/layouts/LoginLayout.vue'
import CommonLayout from '@/layouts/Common.vue'
import FullPageLayout from '@/layouts/FullLayout.vue'
import PageLayout from '@/layouts/PageLayout.vue'



export const DefaultRouter = [
  {
	path: '/login',
	name: 'Login',
	meta: {
		skipAuth: true
	},
	component: () => import(/* webpackChunkName: "login" */'../layouts/LoginLayout.vue')
  },
	{
		path: '/statistics',
		name: 'statistics',
		meta: {
			skipAuth: true,
			title: '综合概览'
		},
		component: () => import(/* webpackChunkName: "overview" */'../views/statistics/index.vue'),
	},
  {
    path: '/download',
    name: 'download APK',
    meta: {
      title: '下载App',
      skipAuth: true,
    },
    component: () => import(/* webpackChunkName: "download" */'../views/setting/DownLoad.vue')
  },
	{
		path: '/',
		name: 'home',
		meta: {
			skipAuth: false
    },
    component: CommonLayout,
		// component: () => import('../layouts/Common.vue'),
		children: [
			// 当 /匹配成功，
			// Home 会被渲染在 CommonLayout 的 <router-view> 中bas
			{
				path: '/home',
        		name: 'Home',
				component: () => import(/* webpackChunkName: "home" */'../views/home/Home.vue'),
			},
			{
				path: '/device',
				name: 'Device',
				meta: {
					title: '设备管理'
				},
        		component: PageLayout,
        			// component: () => import('../layouts/PageLayout.vue'),
				children: [{
						path: '/device/list',
						name: 'DeviceList',
						meta: {
							title: '设备管理'
						},
            		// component: DeviceList,
            			component: () => import(/* webpackChunkName: "device" */'../views/device/DeviceList.vue')
					},
					{
						path: '/device/type',
						name: 'DeviceType',
						meta: {
							title: '设备型号'
						},
            // component: DeviceType,
            component: () => import(/* webpackChunkName: "device" */'../views/device/DeviceTypeList.vue')
					}
				]
			},
			{
				path: '/org',
				name: 'org',
				meta: {
					title: '机构管理'
        },
        component: PageLayout,
				// component: () => import('../layouts/PageLayout.vue'),
				children: [{
					path: '/org',
					name: 'OrgManage',
					meta: {
						title: '机构管理'
					},
          // component: OrgManage,
          component: () => import(/* webpackChunkName: "org" */'../views/org/OrgManage.vue'),
				}]
			},
			{
				path: '/overview',
				name: 'Overview',
				meta: {
					title: '综合概览'
        },
        component: FullPageLayout,
				// component: () => import('../layouts/FullLayout.vue'),
				children: [{
					path: '/overview',
					name: 'overview',
					meta: {
						title: '综合概览'
					},
          // component: Overview,
          component: () => import(/* webpackChunkName: "overview" */'../views/overview/Overview.vue'),
				}, ]
			},
			{
				path: '/supervise',
				name: 'Supervise',
				meta: {
					title: '监管中心'
        },
        component: PageLayout,
				// component: () => import('../layouts/PageLayout.vue'),
				children: [{
						path: '/supervise',
						// name: 'Supervise', 
						meta: {
							title: '监管中心'
						},
            // component: Supervise,
            component: () => import(/* webpackChunkName: "supervise" */'../views/supervise/Supervise.vue'),
					},
					{
						path: '/entity/template',
						name: 'EntityTemplate',
						meta: {
							title: '实体模板'
						},
            // component: EntityTemplateList,
            component: () => import(/* webpackChunkName: "supervise" */'../views/supervise/EntityTemplateList.vue'),
					},
					{
						path: '/rule/template',
						name: 'RuleTemplate',
						meta: {
							title: '监管规则'
						},
            // component: RuleTemplateList,
            component: () => import(/* webpackChunkName: "rule-template" */'../views/ruletemplate/RuleTemplateList.vue'),
					}
				]
      },
      {
				path: '/user',
				name: 'User',
				meta: {
					title: '个人设置'
				},
        // component: UserSetting,
        component: () => import(/* webpackChunkName: "user-set" */'../views/user/UserSetting.vue'),
				children: [
          // {
					// 	path: '/user/setting',
					// 	meta: {
					// 		title: '主题设置'
					// 	},
					// 	component: BasicSetting
					// },
					{
						path: '/user/security',
						name: 'UserSetting',
						meta: {
							title: 'securitySetting'
						},
            // component: SecuritySetting,
            component: () => import(/* webpackChunkName: "user-set" */'../views/user/SecuritySetting.vue'),
          },
          // {
          //   path: '/user/emails',
          //   name: 'sendEmails',
          //   meta: {
          //     title: '邮件群发'
          //   },
          //   component: () => import('../views/user/sendEmails.vue')
          // },
					// {
					// 	path: '/user/set',
					// 	name: 'SystemSetting',
					// 	meta: {
					// 		title: '系统设置'
					// 	},
					// 	component: () => import('../views/logs/SystemSetting')
					// }
				]
			},
			{
				path: '/alarm',
				name: 'alarm',
				meta: {
					title: '告警管理'
        },
        component: PageLayout,
				// component: () => import('../layouts/PageLayout.vue'),
				children: [{
						path: '/alarm/config',
						name: 'AlarmConfig',
						meta: {
							title: '告警设置'
						},
            // component: AlarmConfig,
            component: () => import(/* webpackChunkName: "alarm" */'../views/alarm/AlarmConfig.vue'),
					},
					{
						path: '/alarm/list',
						name: 'AlarmList',
						meta: {
							title: '告警列表'
						},
            // component: AlarmList,
            component: () => import(/* webpackChunkName: "alarm" */'../views/alarm/AlarmList.vue'),
					}
				]
			},
			// 系统日志
			{
				path: '/logs',
				name: 'logs',
				meta: {
					title: '系统日志'
        },
        component: PageLayout,
				// component: () => import('../layouts/PageLayout.vue'),
				children: [
					{
						path: '/logs',
						name: 'SystemLogs',
						meta: {
							title: '系统日志'
						},
						component: () => import(/* webpackChunkName: "logs" */'../views/logs/SystemLogs')
					},
				]
			},
		]
  },
  {
		path: '*',
		name: '404',
		meta: {
			skipAuth: true
		},
		component: () => import(/* webpackChunkName: "not-found" */'../views/404.vue')
	},
]


export const LayoutRouter = [{
	path: '/',
	name: 'home',
	meta: {
		skipAuth: false
	},
	component: () => import(/* webpackChunkName: "common-layout" */'../layouts/Common.vue'),
	children: [
		// 当 /匹配成功，
		// Home 会被渲染在 CommonLayout 的 <router-view> 中
		{
			path: '',
			component: () => import(/* webpackChunkName: "home" */'../views/Home.vue')
		},

		// ...其他子路由
	]
}]